import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpError } from '@services/http-error';
import { LogService } from '@services/log.service';
import { UrlService } from '@services/url.service';
import { ApiList } from '@shared/models/api-list.model';
import Utils from '@shared/providers/utils';
import { isError } from 'lodash';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpService {
  protected httpClient = inject(HttpClient);
  protected urlService = inject(UrlService);
  protected logService = inject(LogService);

  protected handleGetError(response: HttpErrorResponse): Observable<undefined> {
    if (response.status === 404) return of(undefined);
    this.logService.error(response);
    return of(undefined);
  }

  protected handleGetListError<T>(response: HttpErrorResponse): Observable<T> {
    this.logService.error(response);
    return of([] as unknown as T);
  }

  protected handleSearchError<T>(response: HttpErrorResponse): Observable<ApiList<T>> {
    this.logService.error(isError(response.error) ? response.error : new Error('Unknown error occurred'));
    return of({ items: [], count: 0, error: Utils.formatHttpError(response) });
  }

  protected handleCommandError(response: HttpErrorResponse): Observable<HttpError> {
    this.logService.error(response);
    return of(new HttpError(response));
  }
}
